export const validatePassword = (
  password: string
): { isValid: boolean; message?: string } => {
  // Check minimum length
  if (password.length < 8) {
    return {
      isValid: false,
      message: 'Password must be at least 8 characters long',
    };
  }

  // Check for at least one number
  if (!/\d/.test(password)) {
    return {
      isValid: false,
      message: 'Password must contain at least one number',
    };
  }

  // Check for at least one letter
  if (!/[a-zA-Z]/.test(password)) {
    return {
      isValid: false,
      message: 'Password must contain at least one letter',
    };
  }

  // Check for at least one special character
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    return {
      isValid: false,
      message:
        'Password must contain at least one special character (!@#$%^&*(),.?":{}|<>)',
    };
  }

  return { isValid: true };
};

export const getPasswordRequirements = () => [
  'At least 8 characters long',
  'Contains at least one number',
  'Contains at least one letter',
  'Contains at least one special character (!@#$%^&*(),.?":{}|<>)',
];

/** Returns per-rule pass/fail results so the UI can highlight each rule individually. */
export const checkPasswordRules = (
  password: string
): { label: string; passed: boolean }[] => [
  { label: 'At least 8 characters long', passed: password.length >= 8 },
  { label: 'Contains at least one number', passed: /\d/.test(password) },
  { label: 'Contains at least one letter', passed: /[a-zA-Z]/.test(password) },
  {
    label: 'Contains at least one special character (!@#$%^&*(),.?":{}|<>)',
    passed: /[!@#$%^&*(),.?":{}|<>]/.test(password),
  },
];
